<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div class="container-fulid text-center overflow-hidden">
  <div class="row justify-content-center">
    <div class="col-8">
      <h1 class="lifedi-color">
        ระบบจัดการบทความ
      </h1>
    </div>
  </div>
  <div class="row d-flex pb-4 justify-content-center">
    <input type="text" class="form-control search" placeholder="ค้นหาบทความ" name="searchName" [(ngModel)]="search"
      (keyup)="searching()">
    <lifedi-btn lable="เพิ่มบทความ" (click)="addArtical()" customStyle="position: absolute; right: 3%; margin-top: 0px; padding: 0 25px; background: #005C3D; color:
    #FFFFFF">
    </lifedi-btn>
  </div>

  <table class="table table-striped" style="width: 95%; margin: 0 auto;">
    <thead>
      <tr class="d-flex">
        <th scope="col" *ngFor="let col of column" [class]="col.style">{{col.header}}</th>
      </tr>
    </thead>

    <!-- not search -->
    <tbody *ngIf="!isSearch">
      <tr class="d-flex" *ngFor="let artical of rows;" (ngModelChange)="refresh()">
        <td scope="row" class="col">{{ artical[column[0].field] }}</td>
        <td scope="row" class="col">
          <a [href]="locationUrl + '/article/' + artical[column[0].field]" target="_blank">
            {{ artical[column[1].field] }}
          </a>
        </td>
        <td scope="row" class="col">{{ artical[column[2].field] }}</td>

        <!-- {{artical | json}} -->
        <td scope="row" class="col">
          <span *ngIf="artical.ALWAYS_OPEN === 'true'">
            เปิดตลอด
          </span>
          <span *ngIf="artical.ALWAYS_OPEN !== 'true'">
            {{ artical[column[3].field] | date }} /<br> {{ artical[column[3].field2] | date }}
          </span>
        </td>

        <td scope="row" class="col-1">
          <a *ngIf="artical.POLL_ID" (click)="poll(artical)" style="cursor: pointer;">
            <img src="../../../../assets/poll.png" style="width: 20px;">
          </a>
          <a *ngIf="!artical.POLL_ID" style="cursor: not-allowed;">
            <img src="../../../../assets/poll-disable.png" style="width: 20px;">
          </a>
        </td>
        <td scope="row" class="col-1">{{ artical[column[5].field] }}</td>
        <td scope="row" class="col-1">
          <mat-slide-toggle color="primary" [(ngModel)]="!artical[column[6].field]"
            [ngModelOptions]="{ standalone: true }" (change)="changeStatus($event, artical)">
          </mat-slide-toggle>
        </td>
        <td scope="row" class="col-1">
          {{ artical[column[7].field] }}
        </td>
        <td scope="row" class="col-1">
          <a (click)="edit(artical)" style="cursor: pointer;">
            <img src="../../../../assets/edit.png" style="width: 20px;">
          </a>
        </td>
      </tr>
    </tbody>

    <!-- search -->
    <tbody *ngIf="isSearch">
      <tr class="d-flex" *ngFor="let artical of rows; let i = index" (ngModelChange)="refreshSearch()">
        <td scope="row" class="col">{{ artical[column[0].field] }}</td>
        <td scope="row" class="col">
          <a [href]="locationUrl + '/article/' + artical[column[0].field]" target="_blank">
            {{ artical[column[1].field] }}
          </a>
        </td>
        <td scope="row" class="col">{{ artical[column[2].field] }}</td>

        <td scope="row" class="col">
          <span *ngIf="artical.ALWAYS_OPEN === 'true'">
            เปิดตลอด
          </span>
          <span *ngIf="artical.ALWAYS_OPEN !== 'true'">
            {{ artical[column[3].field] | date }} /<br> {{ artical[column[3].field2] | date }}
          </span>
        </td>

        <td scope="row" class="col-1">
          <a *ngIf="artical.POLL_ID" (click)="poll(artical)" style="cursor: pointer;">
            <img src="../../../../assets/poll.png" style="width: 20px;">
          </a>
          <a *ngIf="!artical.POLL_ID" style="cursor: not-allowed;">
            <img src="../../../../assets/poll-disable.png" style="width: 20px;">
          </a>
        </td>
        <td scope="row" class="col-1">{{ artical[column[5].field] }}</td>
        <td scope="row" class="col-1">
          <mat-slide-toggle color="primary" [(ngModel)]="!artical[column[6].field]"
            [ngModelOptions]="{ standalone: true }" (change)="changeStatus($event, artical)">
          </mat-slide-toggle>
        </td>
        <td scope="row" class="col-1">
          {{ artical[column[7].field] }}
        </td>
        <td scope="row" class="col-1">
          <a (click)="edit(artical)" style="cursor: pointer;">
            <img src="../../../../assets/edit.png" style="width: 20px;">
          </a>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="d-flex justify-content-center p-2">
    <ngb-pagination *ngIf="!isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refresh()">
    </ngb-pagination>
    <ngb-pagination *ngIf="isSearch" [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize"
      (pageChange)="refreshSearch()">
    </ngb-pagination>
  </div>
  <select class="custom-select" style="width: auto; float: right; margin-right: 30px;" [(ngModel)]="pageSize"
    (ngModelChange)="refresh()">
    <option [ngValue]="10">10 items per page</option>
    <option [ngValue]="15">15 items per page</option>
    <option [ngValue]="20">20 items per page</option>
  </select>
</div>
